import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mydeq-footer',
  templateUrl: './mydeq-footer.component.html',
})

export class MydeqFooterComponent implements OnInit {
  constructor() { }
  ngOnInit() { }
}